import { intersection } from 'lodash'
//import { INTERNAL_ROLE } from '../router/roles.ts'
import { UserInfo } from '../apis/auth/auth.def.ts'
import { IdeyaRoute } from '../router/router.def.ts'

export const hasAccess = (
  routePageType: string,
  user: UserInfo,
  route: IdeyaRoute
) => {
  const {
    allowedFirmRoles = [],
    //allowedGroupRoles = [],
    deniedFirmRoles = [],
    deniedGroupRoles = [],
    allowedInternalRoles = [],
    pageType,
    globalCanAccess = true,
  } = route
  const { firmRole, groupRole, role, region } = user

  const matchedAllowedFirmRoles = intersection(allowedFirmRoles, [firmRole])
  const matchedDeniedFirmRoles = intersection(deniedFirmRoles, [firmRole])
  const matchedDeniedGroupRoles = intersection(deniedGroupRoles, [groupRole])
  const matchedAllowedInternalRoles = intersection(allowedInternalRoles, [role])
  //const isInternalMasterOrAdmin =
  //  role === INTERNAL_ROLE.ROLE_MASTER || role === INTERNAL_ROLE.ROLE_ADMIN;

  if (!globalCanAccess && region === 'Global') return false

  return (
    ((matchedAllowedFirmRoles.length > 0 &&
      matchedDeniedGroupRoles.length === 0) ||
      (matchedAllowedInternalRoles.length > 0 &&
        matchedDeniedFirmRoles.length === 0 &&
        matchedDeniedGroupRoles.length === 0)) &&
    //isInternalMasterOrAdmin
    routePageType === pageType
  )
}
